module.exports = __webpack_public_path__ + "static/media/21KM.a2bce9f3.webp";